module.exports = __webpack_public_path__ + "static/og_image-dcb09edbdf3593b2ca58435619142a46.png";